import { render, staticRenderFns } from "./SinMenuConAlertas.vue?vue&type=template&id=f8e809ac&scoped=true"
import script from "./SinMenuConAlertas.vue?vue&type=script&lang=js"
export * from "./SinMenuConAlertas.vue?vue&type=script&lang=js"
import style0 from "./SinMenuConAlertas.vue?vue&type=style&index=0&id=f8e809ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e809ac",
  null
  
)

export default component.exports